





















import { computed, defineComponent, ref } from '@vue/composition-api'
import draggable from 'vuedraggable'

interface SortItem {
  label: string
  extra?: string
  image: string
}

export default defineComponent({
  name: 'VSort',

  components: {
    draggable
  },

  props: {
    items: {
      type: Array as () => SortItem[],
      required: true
    },
    shuffledIndeces: {
      type: Array as () => number[],
      required: true
    }
  },

  setup(props) {
    const shuffledItems = ref(
      props.shuffledIndeces.map(index => props.items[index])
    )

    const isCorrect = computed(() => {
      return JSON.stringify(shuffledItems.value) === JSON.stringify(props.items)
    })

    return {
      shuffledItems,
      isCorrect
    }
  }
})
